import React from "react";
import WinnerInfoForm from "./WinnerInfoForm";
import { DeadlineDisplay } from "../common";

const InfoInputScreen = ({
  deadline,
  onSubmit,
  loading,
  eventName,
}) => {
  return (
    <div className="newyear-info-input">
      <div className="newyear-info-input__header">
        <h2 className="newyear-info-input__title">당첨자 정보 입력</h2>
        {eventName && (
          <p className="newyear-info-input__event-name">{eventName}</p>
        )}
      </div>

      {deadline && (
        <DeadlineDisplay
          deadline={deadline}
          label="입력 마감"
        />
      )}

      <div className="newyear-info-input__description">
        <p>경품 수령을 위해 아래 정보를 입력해주세요.</p>
      </div>

      <WinnerInfoForm
        onSubmit={onSubmit}
        loading={loading}
        submitLabel="정보 제출하기"
      />
    </div>
  );
};

export default InfoInputScreen;
